import React, { useEffect, useState } from 'react';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import CustomLocationCard from '../../locations/locationCard/CustomLocationCard';
import TinyLoader from '../../common/tiny-loader/TinyLoader';

import { getLocationById } from '../../../redux/visitor-list/actions/createAppoinment.action';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { ISelectProperty, locationProps, unitsDataInterface } from '../interface/Visitor.interface';

import SearchIcon from '../../../images/icon-search.svg';
import NoUnits from '../../../images/no-units-found.svg';
import styles from './SelectProperty.module.css';
import { getLocation, getSearchLocation } from '../../../redux/location/actions/location.action';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAppointmentUnits } from '../../../redux/appointment-units/actions/appointmentUnits.action';

export const SelectProperty = ({
    setSelectedProperty,
    selectedProperty,
    onClickHandler,
    setAppointmentStep,
    appointmentStep,
}: ISelectProperty) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const [unitsData, setUnitsData] = useState<unitsDataInterface[]>([]);
    const { data, loading } = useSelector((state: IRootState) => state.locationReducer);

    useEffect(() => {
        if (!data.locations && !data.locationinvitedlist) {
            setUnitsData([]);
        } else {
            if (data?.locations?.length || data?.locationinvitedlist?.length) {
                setUnitsData([...data.locations, ...data.locationinvitedlist]);
            }
        }
    }, [data]);

    useEffect(() => {
        dispatch(getLocation(undefined, undefined, true));
    }, []);

    const handleLocationCard = (location: locationProps) => {
        // navigate('/add-availability/units', { state: { locationId: location.id, type: 'add-availability', locationName: location?.name } });
        setSelectedProperty(location.id);
        onClickHandler(location);
        setAppointmentStep(appointmentStep + 1);
    };

    // debounce functionality for search locations
    let timer: null | ReturnType<typeof setTimeout>;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            dispatch(getSearchLocation(e.target.value));
        }, 1000);
    };
    //debounce functionality end

    return (
        <div>
            <div className={`${styles.inlineItems} ${styles.searchProperty}`}>
                <h2>Select Property</h2>
                <div className={styles.searchContainer}>
                    <div className={styles.searchBox}>
                        <input type="text" placeholder="Search for Property" onChange={(e) => handleChange(e)} maxLength={50} />
                        <img className={styles.searchIconImage} src={SearchIcon} alt="search-icon" />
                    </div>
                </div>
            </div>
            <div className={styles.propertyListing}>
                <div className={styles.locationWrapper}>
                    {unitsData && !!unitsData.length
                        ? unitsData.map((location: AnyIfEmpty<object>, index: number) => (
                            <div className={` ${styles.locationCardActive} ${styles.locationCard}`} key={index}>
                                <CustomLocationCard
                                    location={location}
                                    handleLocationCard={() => handleLocationCard(location)}
                                    selected={selectedProperty === location?.id ? true : false}
                                />
                            </div>
                        ))
                        : !loading &&
                        unitsData &&
                        !unitsData.length && (
                            <div className={styles.noUnits}>
                                <img src={NoUnits} alt="no-units" />
                                <p className={styles.noUnitsFoundText}>No Location Found</p>
                            </div>
                        )}
                </div>
            </div>
            {loading && <TinyLoader />}
        </div>
    );
};
